import { useEffect } from 'react';

export function usePageTitle(text?: string | null) {
  useEffect(() => {
    if (text) document.title = `${text}`;
  }, [text]);
}
